<template>
	<app-page>
		<app-heading :title="isNew ? 'New Subscriber' : subscriber.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'subscribers' }">Cancel</app-button>
				</app-section-actions>
				<input-select
					label="Subscriber type"
					v-model="subscriberType"
					:items="subscriberTypes"
					@change="onSubscriberTypeChange"
				/>
				<input-select
				v-if="subscriberType === 'user'"
					label="User"
					v-model="subscriber.user_id"
					:errors="errors.user_id"
					:items="users"
				/>
				<input-text
					v-if="subscriberType === 'external'"
					type="email"
					label="Email"
					v-model="subscriber.email"
					:errors="errors.email"
				/>
				<input-text
					v-if="subscriberType === 'webhook'"
					label="Webhook URL"
					v-model="subscriber.webhook"
					:errors="errors.webhook"
				/>
				<input-text
					v-if="subscriberType === 'webhook' || subscriberType === 'external'"
					label="Name"
					v-model="subscriber.name"
					:errors="errors.name"
				/>
				<input-combobox
					label="Tags"
					multiple
					v-model="subscriber.tags"
					:items="tags"
					:errors="errors.tags"
				/>
				<input-combobox
					label="Notification types"
					multiple
					v-model="subscriber.types"
					:items="filteredTypes"
					:errors="errors.types"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
// @See for subscriber type, seems to be a bit too much computed
export default {
	async created() {
		try {
			const group = await this.$ravello.request()
				.to('notifications')
				.to('groups')
				.to(this.group)
				.get()
			this.tags = group.tags || []

			const [types, users] = await Promise.all([
				this.$ravello.request()
					.to('notifications')
					.to('types')
					.dataSource(),
				this.$ravello.request()
					.v(3)
					.to('users')
					.dataSource(),
			])

			this.types = types
			this.users = users

			if (this.id !== 'new') {
				this.$store.dispatch('app/startLoading')
				const subscriber = await this.$ravello.request()
					.to('notifications')
					.to('subscribers')
					.to(this.id)
					.get()

				this.subscriber = {
					email: subscriber.email,
					name: subscriber.name,
					webhook: subscriber.webhook,
					tags: subscriber.tags || [],
					types: subscriber.types || [],
					user_id: subscriber.user_id,
				}

				if (subscriber.user_id) {
					this.subscriberType = 'user'
				} else if (subscriber.webhook) {
					this.subscriberType = 'webhook'
				}

				this.$store.dispatch('app/stopLoading')
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data.message)
		}
	},
	data() {
		return {
			tags: [],
			types: [],
			users: [],
			subscriber: {
				email: '',
				name: '',
				webhook: null,
				user_id: null,
				tags: [],
				types: [],
			},
			errors: {},

			subscriberType: 'external',
			subscriberTypes: [{
				text: 'External',
				value: 'external',
			}, {
				text: 'User',
				value: 'user',
			}, {
				text: 'Webhook',
				value: 'webhook',
			}],
		}
	},
	computed: {
		id() {
			return this.$route.params.subscriber
		},
		group() {
			return this.$route.params.group
		},
		isNew() {
			return this.id === 'new'
		},
		filteredTypes() {
			return this.types.filter(type => !type.only || type.only.indexOf(this.subscriberType) !== -1)
		},
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')

			if (this.subscriber.user_id) {
				const user = await this.$ravello.request()
					.v(3)
					.to('users')
					.to(this.subscriber.user_id)
					.get()

				this.subscriber.email = user.email
				this.subscriber.name = `${user.firstName} ${user.lastName}`.trim()
			}

			try {
				if (this.isNew) {
					await this.$ravello.request()
						.to('notifications')
						.to('subscribers')
						.create({
							...this.subscriber,
							group: this.group,
						})
				} else {
					await this.$ravello.request()
						.to('notifications')
						.to('subscribers')
						.to(this.id)
						.update(this.subscriber)
				}

				this.$store.dispatch('app/stopLoading')
				this.$router.push({ name: 'subscribers' })
				this.$notifications.pushAlert('success', `Subscriber successfully ${this.isNew ? 'added' : 'updated'}`)
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}

				this.$store.dispatch('app/stopLoading')
			}
		},

		onSubscriberTypeChange() {
			switch (this.subscriberType) {
			case 'webhook':
				this.subscriber.webhook = ''
				this.subscriber.user_id = null
				break
			case 'user':
				this.subscriber.webhook = null
				break
			default:
				this.subscriber.user_id = null
				this.subscriber.webhook = null
			}

			this.subscriber.types = this.subscriber.types.filter(type => this.filteredTypes
				.find(filteredType => filteredType.value === type))
		},
	},
}
</script>
